// extracted by mini-css-extract-plugin
module.exports = {"DocPageSeparator":"DocPageSeparator_DocPageSeparator__fArKz"};